import React, { useEffect, useState } from "react";
import InputOtp from "./InputOtp/InputOtp";
import { useDispatch, useSelector } from "react-redux";
import UNIVERSAL from "../../../../config/config";
import { toast } from "react-toastify";
import { fetchHomepageProfile } from "../../../../store/homepage-profile-slice";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useNavigate } from "react-router-dom";

const OTPModal = (props) => {
  const user = useSelector((state) => state?.user?.user);
  const { appRefId, enteredNumber } = props;
  const [counter, setCounter] = useState(59);
  const [showCounter, setShowCounter] = useState(true);
  const [otpNumber1, setOtpNumber1] = useState();
  const [otpNumber2, setOtpNumber2] = useState();
  const [otpNumber3, setOtpNumber3] = useState();
  const [otpNumber4, setOtpNumber4] = useState();
  const [otpNumber5, setOtpNumber5] = useState();
  const [verificationCode, setVerificationCode] = useState();
  const [otp, setOtp] = React.useState("");
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  function handleEnteredOtpNumber1(value) {
    setOtpNumber1(value);
  }
  function handleEnteredOtpNumber2(value) {
    setOtpNumber2(value);
  }
  function handleEnteredOtpNumber3(value) {
    setOtpNumber3(value);
  }
  function handleEnteredOtpNumber4(value) {
    setOtpNumber4(value);
  }
  function handleEnteredOtpNumber5(value) {
    setOtpNumber5(value);
  }

  useEffect(() => {
    if (otpNumber1 && otpNumber2 && otpNumber3 && otpNumber4 && otpNumber5) {
      setVerificationCode(otpNumber1 + otpNumber2 + otpNumber3 + otpNumber4 + otpNumber5);
    }
  }, [otpNumber1, otpNumber2, otpNumber3, otpNumber4, otpNumber5]);

  async function handleOtpConfirm() {
    setIsBtnDisabled(true);
    if (enteredNumber.length > 9 && appRefId) {
      return fetch(UNIVERSAL.BASEURL_1 + "/bizv2/whatsapp/link_whatsapp_account", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
        },
        body: JSON.stringify({
          business_id: String(user?.app_business_id),
          whatsapp_number: enteredNumber,
          country_dialling_code: "91",
          app_reference_id: String(appRefId),
          verification_code: otp,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.success) {
             fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/whatsapp/validate", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                app_business_id: user?.app_business_id,
              }),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                if (responseJson?.data?.is_valid_business_whatsapp_number) {
                  toast("WhatsApp account connected successfully", { type: "success" });
                  props?.setIsWhatsAppLinked?.(true);
                  dispatch(fetchHomepageProfile({ businessId: user?.app_business_id }));
                  navigate("/");
                  props.closeOtpModal();
                  setIsBtnDisabled(false);
                } else {
                  props?.setIsBusinessAssociated(false);
                  props.closeOtpModal();
                  setIsBtnDisabled(false);
                }
              })
              
            fetch(UNIVERSAL.BASEURL_1 + "/bizv2/social/connect_accounts", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe"
                },
                body: JSON.stringify({
                  messenger: false,
                  instagram: false,
                  whatsapp: true,
                  business_id:user?.app_business_id,
                }),
              })
                .then((response) => response.json())
                .then((responseJson) => {
               
                });
          } else {
            if (responseJson?.data?.error_type === "INVALID_VERIFICATION_CODE") {
              toast("Invalid Otp", { type: "error" });
              setIsBtnDisabled(false);
            } else {
              toast("Unable to connect your whatsapp account. Please make sure the whatsapp account is a business account", { type: "error" });
              props.closeOtpModal();
              setIsBtnDisabled(false);
            }
          }

        })
        .catch((error) => {
          toast(error?.message ?? "Unable to connect your whatsapp account", { type: "error" });
        });
    }
  }

  function handleCloseOtpModal() {
    props.closeOtpModal();
  }

  useEffect(() => {
    console.log(otp);
  }, [otp]);

  return (
    <div className="modalBg">
      <div class="modal" tabIndex="-1">
        <div class="modal-dialog modal-dialog-otp">
          <div class="modal-content">
            <div className="modalClose">
              <img className="textModalClose" src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/close-circle.svg" alt="close-modal-img" onClick={handleCloseOtpModal} />
            </div>
            <div className="modal-main">
              <div className="modalHeading">
                <h6 className="modal-heading">Confirm WhatsApp account</h6>
                <p className="modal-subHeading modal-subHeading-otp">
                  Please enter the code in WhatsApp msg sent to +91 {enteredNumber && enteredNumber}.{" "}
                  <button className="modal-subHeading-otp-changeBtn" onClick={handleCloseOtpModal}>
                    Change
                  </button>
                </p>
              </div>
              <div className="otpDiv">
                {/* <InputOtp enteredNumber={handleEnteredOtpNumber1} />
                <InputOtp enteredNumber={handleEnteredOtpNumber2} />
                <InputOtp enteredNumber={handleEnteredOtpNumber3} />
                <InputOtp enteredNumber={handleEnteredOtpNumber4} />
                <InputOtp enteredNumber={handleEnteredOtpNumber5} /> */}
                <MuiOtpInput length={5} value={otp} onChange={(newVal) => setOtp(newVal)} />
              </div>
              {counter > 0 && (
                <div className="counterDiv">
                  <p className="counter">00:{counter}</p>
                </div>
              )}
              {!counter > 0 && (
                <p className="connectWhatsApp-number-invalid-code">
                  Time Out
                  <span className="modal-subHeading-otp-resendBtn" onClick={handleCloseOtpModal}>
                    Resend OTP
                  </span>
                </p>
              )}
              <div className="otpModalBtn">
                <button
                  className={otp?.length >= 5 && counter > 0 && isBtnDisabled === false ? "otpModalDoneBtn" : "disabledConfirmOtpBtn"}
                  disabled={otp?.length < 5 && isBtnDisabled === false}
                  onClick={handleOtpConfirm}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPModal;
